// extracted by mini-css-extract-plugin
export default {"footerCancelButton":"ZyPE0","contentWrapper":"DekNM","offerContainer":"pb_Pf","offerLink":"xbYxs","offerModal":"dBChm","noAlignment":"EYEnU"};